import './more.scss';

import type { HasFiscalPrinter } from '@pos/app/scripts/services/has-fiscal-printer';
import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { Barcodes } from '@pos/app/scripts/services/barcodes';
import { Broadcaster } from '@core/app/scripts/services/broadcaster';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { LastTransaction } from '@pos/app/scripts/services/last-transaction';
import { SessionManager } from '@shared/app/scripts/services/session-manager';
import { SettingsManager } from '@shared/app/scripts/services/settings-manager';

/*
 * Component responsible for /more route.
 */
angular
  .module('posApp')
  .directive(
    'more',
    (
      barcodes: Barcodes,
      broadcaster: Broadcaster,
      displayMessage: DisplayMessage,
      hasFiscalPrinter: HasFiscalPrinter,
      lastTransaction: LastTransaction,
      navigateTo: NavigateTo,
      paymentTypes,
      pinProvider,
      pos,
      printLastReceipt,
      sessionManager: SessionManager,
      settingsManager: SettingsManager,
      translate: ng.translate.ITranslateService,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./more.html').default,

      link: function ($scope: any, element, attrs) {
        const $translate = translate;

        $scope.pos = pos;
        $scope.openEmailPopup = false;

        $scope.navigateToView = (view) => {
          navigateTo(view);
        };

        $scope.onChangeCashier = () => {
          pos.onChangeCashier();
        };

        $scope.getTurnover = () => {
          navigateTo('pos.turnover');
        };

        $scope.getEos = () => {
          if (hasFiscalPrinter()) {
            navigateTo('pos.route#fiscal-eos');
          } else if (settingsManager.settings.closingProcedure === 'eos') {
            navigateTo('pos.route#eos-overview');
          } else if (settingsManager.settings.closingProcedure === 'none') {
            displayMessage.message(
              $translate.instant('ClosingDayProcedureNotConfigured'),
            );
          } else {
            displayMessage.message(
              $translate.instant('ClosingDayProcedureNotConfigured'),
            );
          }
        };

        $scope.showPinReprint = () => {
          return settingsManager.settings.pinProvider === 'payPlaza4';
        };

        $scope.showWithdrawal = () => {
          return settingsManager.settings.paymentMethods?.withdrawal?.available;
        };

        $scope.getTransactionsData = (transaction) => {
          // Parameter transaction added. If value = 'buffer' we select the buffer receipts
          if (transaction && transaction == 'buffer') {
            navigateTo('pos.route#select-buffer');
          } else {
            navigateTo('pos.route#select-receipt');
          }
        };

        $scope.reprintLastTransaction = () => {
          displayMessage.message({
            message: $translate.instant('pos.reprinting'),
            type: 'info',
            mini: true,
          });

          printLastReceipt().then(angular.noop, () => {
            displayMessage.message({
              message: $translate.instant('CannotReprintLastReceipt'),
              type: 'alert',
              time: 4000,
            });
          });
        };

        $scope.reprintLastPINReceipt = () => {
          if (
            settingsManager.settings.pinId &&
            settingsManager.settings.pinProvider !== 'none' &&
            paymentTypes.rules.pin.coupled === true
          ) {
            pinProvider.reprintPINReceipt();
          } else {
            displayMessage.message(
              $translate.instant(
                'PayPlaza PIN key not configured in settings!',
              ),
            );
          }
        };

        $scope.transitOrderIn = () => {
          pos.config.transitDirection = 'from';
          navigateTo('pos.route#transit-order');
        };

        $scope.transitOrderOut = () => {
          pos.config.transitDirection = 'to';
          navigateTo('pos.route#transit-order');
        };

        $scope.posWithdrawal = () => {
          pos.config.cashDirection = 'posWithdrawal';
          navigateTo('pos.route#withdrawal');
        };

        $scope.posDeposit = () => {
          pos.config.cashDirection = 'posDeposit';
          navigateTo('pos.route#withdrawal');
        };

        $scope.posOpenDrawer = () => {
          pos.config.cashDirection = 'posOpenDrawer';
          navigateTo('pos.route#open-drawer');
        };

        $scope.toggleEmailPopup = () => {
          broadcaster.send('setFocus', ['receiptEmail', true]);
          $scope.openEmailPopup = $scope.openEmailPopup ? false : true;
        };

        $scope.hasLastReceipt = angular.isObject(lastTransaction.get());

        /*
         * Get last transation and ask for email
         */
        $scope.prepareForEmailLastReceipt = () => {
          $scope.transaction = lastTransaction.get();
          if ($scope.transaction) {
            $scope.toggleEmailPopup();
          } else {
            displayMessage.message($translate.instant('LastReceiptNotFound'));
          }
        };

        $scope.logout = () => {
          displayMessage.message({
            message: $translate.instant('AreYouSure'),
            type: 'prompt',
            callback: (result: any) => {
              if (result == 'yes') {
                pos.resetTransaction('logout');

                // go to landing page
                sessionManager.logout();
              }
            },
          });
        };

        $scope.reloadFeed = () => {
          barcodes.reload();
        };
      },
    }),
  );
